import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import api from '../services/api';

/**
 * RC14.2 Phase 10 — DEV-only diagnostic banner showing the current tenant, so a developer can
 * see at a glance which tenant's data a page is scoped to while debugging isolation. Renders
 * nothing outside development (checked via CRA's build-time NODE_ENV, not a runtime toggle) and
 * never gates any behavior — purely informational.
 */
const TenantDevBanner = () => {
  const [tenant, setTenant] = useState(null);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;
    let cancelled = false;
    api.get('/auth/me/tenant')
      .then((res) => { if (!cancelled) setTenant(res.data); })
      .catch(() => { if (!cancelled) setTenant(null); });
    return () => { cancelled = true; };
  }, []);

  if (process.env.NODE_ENV !== 'development' || !tenant) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.5,
        py: 0.25,
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
      }}
      data-testid="tenant-dev-banner"
    >
      <ApartmentIcon fontSize="small" />
      <Typography variant="caption" fontWeight={600}>
        DEV — Tenant: {tenant.name} ({tenant.code})
      </Typography>
    </Box>
  );
};

export default TenantDevBanner;
